<template>
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"  
  >
    <path d="M8.29541 15.7159C8.68882 16.1036 9.32196 16.0989 9.70959 15.7055C10.0972 15.3121 10.0925 14.6789 9.69911 14.2913L4.32876 8.9999H17.9999C18.5522 8.9999 18.9999 8.55218 18.9999 7.9999C18.9999 7.44761 18.5522 6.9999 17.9999 6.9999H4.33536L9.69911 1.71501C10.0925 1.32739 10.0972 0.694241 9.70959 0.300835C9.32196 -0.0925711 8.68882 -0.0972593 8.29541 0.290362L1.37122 7.11275C0.874307 7.60236 0.874306 8.40395 1.37122 8.89356L8.29541 15.7159Z" />
  </svg>
</template>
